import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que fuerza el scroll al inicio en cada cambio de ruta
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Método 1: window.scrollTo
    window.scrollTo(0, 0);
    
    // Método 2: document.documentElement
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Método 3: scroll con opciones
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    // Backup múltiple con diferentes delays
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
    
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 100);

  }, [pathname]);

  return null;
};

export default ScrollToTop;

